export default __webpack_public_path__ + "static/media/logo_mobile.bfea5458.png";